export interface LoadStatusInTransitData {
  loadId: string;
  latitude: number;
  longitude: number;
  locationTime: string;
}
